module.exports = __webpack_public_path__ + "img/ks_logo.bc4d78d.bc4d78de.jpg";